import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'indicator']
  static values = { selected: Number }

  connect () {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      this.updateSelection()
    })
  }

  select (event) {
    const button = event.currentTarget
    const index = this.buttonTargets.indexOf(button)

    if (index !== this.selectedValue) {
      this.selectedValue = index
      this.updateSelection()

      // Dispatch custom event for other components to listen to
      this.dispatch('change', {
        detail: {
          index,
          value: button.dataset.value
        }
      })
    }
  }

  updateSelection () {
    const selectedButton = this.buttonTargets[this.selectedValue]

    if (selectedButton && this.hasIndicatorTarget) {
      // Calculate position relative to the container's padding
      const buttons = this.buttonTargets
      let leftOffset = 0

      // Sum up widths of all buttons before the selected one
      for (let i = 0; i < this.selectedValue; i++) {
        leftOffset += buttons[i].offsetWidth
      }

      const width = selectedButton.offsetWidth

      this.indicatorTarget.style.transform = `translateX(${leftOffset}px)`
      this.indicatorTarget.style.width = `${width}px`
    }

    // Update button styles
    this.buttonTargets.forEach((button, index) => {
      if (index === this.selectedValue) {
        button.classList.add('text-black', 'relative', 'z-10')
        button.classList.remove('text-gray-600')
      } else {
        button.classList.add('text-gray-600')
        button.classList.remove('text-black', 'relative', 'z-10')
      }
    })
  }

  selectedValueChanged () {
    this.updateSelection()
  }
}
